module.exports = __webpack_public_path__ + "static/img/monitorPhoto.b2ef887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/monitorPhoto.png
// module id = 68
// module chunks = 0